var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('template-simple',[_c('div',{attrs:{"id":"boleto"}})])}
var staticRenderFns = []

export { render, staticRenderFns }